import { useCallback, useEffect, useState } from 'react';
import { coursesApi } from '@/api/endpoints';
import { useAuthStore } from '@/store/auth';

/**
 * Joriy foydalanuvchining kursdagi tugatilgan darslari. Shaxsiy ma'lumot — prerender
 * HTML da yo'q, hydration'dan keyin (auth tiklangach) yuklanadi. Anonimda bo'sh to'plam.
 */
export function useCourseProgress(courseSlug: string | undefined) {
  const userId = useAuthStore((s) => s.user?.id);
  const [completed, setCompleted] = useState<Set<string>>(() => new Set());

  useEffect(() => {
    setCompleted(new Set());
    if (!courseSlug || userId === undefined) return;
    let cancelled = false;
    coursesApi
      .progress(courseSlug)
      .then((res) => {
        if (!cancelled) setCompleted(new Set(res.data.completedLessons));
      })
      .catch(() => {
        /* progress ixtiyoriy — sahifa baribir ishlaydi */
      });
    return () => {
      cancelled = true;
    };
  }, [courseSlug, userId]);

  const replace = useCallback((lessons: string[]) => setCompleted(new Set(lessons)), []);

  return { completed, replace, loggedIn: userId !== undefined };
}
